import { mapPhaseFormsToAllocationParts } from '../allocation/allocationForm';
import { AllocationPartForm, PhaseForm } from '../Timeline.types';

export function calculateAllocationPartVariants(
    cellSpanBeforePhase: number,
    cellSpanAfterPhase: number,
    dayIndexInPhase: number,
    confirmedCellSpan: number,
    position: 'Before-Main' | 'Main' | 'After-Main',
    formPerDay: AllocationPartForm,
): { form: AllocationPartForm; variant: 'Solid' | 'Deleted' } {
    const areLeftCellsDeleted = cellSpanBeforePhase < 0;
    const areRightCellsDeleted = cellSpanAfterPhase < 0;
    const isCurrentIndexLeftDeleted = dayIndexInPhase < Math.abs(cellSpanBeforePhase);
    const isCurrentIndexRightDeleted = confirmedCellSpan - dayIndexInPhase - 1 < Math.abs(cellSpanAfterPhase);

    if (position === 'Before-Main') {
        if (areLeftCellsDeleted && isCurrentIndexLeftDeleted) {
            return {
                form: formPerDay,
                variant: 'Deleted',
            };
        }
    }

    if (position === 'Main') {
        if (
            (areLeftCellsDeleted && isCurrentIndexLeftDeleted) ||
            (areRightCellsDeleted && isCurrentIndexRightDeleted)
        ) {
            return {
                form: formPerDay,
                variant: 'Deleted',
            };
        }
    }

    if (position === 'After-Main') {
        if (areRightCellsDeleted && isCurrentIndexRightDeleted) {
            return {
                form: formPerDay,
                variant: 'Deleted',
            };
        }
    }

    return {
        form: formPerDay,
        variant: 'Solid',
    };
}

export function calculateDaysForConfirmedAllocationParts(
    phaseForm: PhaseForm,
    confirmedCellSpan: number,
    cellSpanBefore: number,
    cellSpanAfter: number,
    position: 'Before-Main' | 'Main' | 'After-Main',
    hasTemporaryPhasesBefore: boolean,
    hasTemporaryPhasesAfter: boolean,
): { form: AllocationPartForm; variant: 'Solid' | 'Deleted' }[] {
    // Check if attempted deletion exceeds available days
    if (
        (position === 'Before-Main' && cellSpanBefore < 0 && Math.abs(cellSpanBefore) > confirmedCellSpan) ||
        (position === 'Main' &&
            cellSpanBefore + cellSpanAfter < 0 &&
            Math.abs(cellSpanBefore + cellSpanAfter) > confirmedCellSpan) ||
        (position === 'After-Main' && cellSpanAfter < 0 && Math.abs(cellSpanAfter) > confirmedCellSpan)
    ) {
        throw new Error("It's impossible to delete more cells than existing");
    }

    const formsPerDay = mapPhaseFormsToAllocationParts(
        confirmedCellSpan,
        phaseForm,
        cellSpanBefore > 0 || hasTemporaryPhasesBefore,
        cellSpanAfter > 0 || hasTemporaryPhasesAfter,
    );

    // Generate an object for every day
    return formsPerDay.map((formPerDay, index) => {
        return calculateAllocationPartVariants(
            cellSpanBefore,
            cellSpanAfter,
            index,
            confirmedCellSpan,
            position,
            formPerDay,
        );
    });
}
